import React, { useState } from 'react';
import { api } from '../../services/api';
import './ReAuthModal.css';
import '../../global.css';

const ReAuthModal = ({ show, onConfirm, onCancel, onAuthenticated }) => {
  const [username, setUsername] = useState(sessionStorage.getItem("username") || "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (!show) return null;

  const handleReAuth = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const params = { username, password };
      const queryString = new URLSearchParams(params).toString();
      const url = `/api/admin/authenticate?${queryString}`;
      const response = await api.get(url);
      const token = response.data.accessToken;
      const expiresIn = response.data.expiresIn;
      localStorage.setItem("accessToken", token);
      localStorage.setItem("expiresIn", expiresIn);
      if (onAuthenticated) onAuthenticated(token);
      setPassword("");
      onConfirm(); // Close modal
    } catch (err) {
      setError("Re-authentication failed. Please check your credentials.");
      console.error("Re-authentication failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reauth-modal-backdrop">
      <div className="reauth-modal">
        <h3>Session Expired</h3>
        <form onSubmit={handleReAuth}>
          <div>
            <label>Username</label>
            <input
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Username"
              autoFocus
              disabled={loading}
            />
          </div>
          <div>
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Password"
              disabled={loading}
            />
          </div>
          {error && <div className="reauth-error">{error}</div>}
          <div className="reauth-modal-actions">
            <button type="submit" disabled={loading}>Re-Authenticate</button>
            <button type="button" onClick={onCancel} disabled={loading}>Logout</button>
          </div>
          {loading && (
            <div className="spinner" style={{ margin: "1rem auto", display: "block" }} />
          )}
        </form>
      </div>
    </div>
  );
};

export default ReAuthModal;